import theme from "./public/assets/generated/themes/drinking_water.json"
import { ThemeMetaTagging } from "./src/assets/generated/metatagging/drinking_water"
import selected_element from "./src/assets/generated/layers/selected_element.json"
import gps_location from "./src/assets/generated/layers/gps_location.json"
import gps_location_history from "./src/assets/generated/layers/gps_location_history.json"
import home_location from "./src/assets/generated/layers/home_location.json"
import gps_track from "./src/assets/generated/layers/gps_track.json"
import range from "./src/assets/generated/layers/range.json"
import last_click from "./src/assets/generated/layers/last_click.json"
import favourite from "./src/assets/generated/layers/favourite.json"
import summary from "./src/assets/generated/layers/summary.json"
import search from "./src/assets/generated/layers/search.json"
import geocoded_image from "./src/assets/generated/layers/geocoded_image.json"
import MetaTagging from "./src/Logic/MetaTagging"
import ThemeConfig from "./src/Models/ThemeConfig/ThemeConfig"
import SingleThemeGui from "./src/UI/SingleThemeGui.svelte"


async function main() {
        MetaTagging.setThemeMetatagging(new ThemeMetaTagging())
        theme.layers.push(<any> selected_element)
    theme.layers.push(<any> gps_location)
    theme.layers.push(<any> gps_location_history)
    theme.layers.push(<any> home_location)
    theme.layers.push(<any> gps_track)
    theme.layers.push(<any> range)
    theme.layers.push(<any> last_click)
    theme.layers.push(<any> favourite)
    theme.layers.push(<any> summary)
    theme.layers.push(<any> search)
    theme.layers.push(<any> geocoded_image)
        // LAYOUT.ADD_CONFIG
        const target =  document.getElementById("maindiv")
        const childs = Array.from(target.children)
        new SingleThemeGui({
            target,
            props: { theme: new ThemeConfig(theme, true, {definitionRaw: theme}) },
        })
        childs.forEach(ch => target.removeChild(ch))
        Array.from(document.getElementsByClassName("delete-on-load")).forEach(el => {
                    el.parentElement.removeChild(el)
                })
}
main()
